export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      UserIdentity: 'member003',
      ClientFlg: false,
      MentorFlg: true,
      ProMentorFlg: true,
      MentorInfo: {
        UserName: 'プロメンター太郎',
        Sex: 2,
        Birthday: '1980/10/22',
        RegionCd: 4,
        MailAddress: 'aaa@aaa.com',
        SoudanCount: 2,
        ComplaintCount: 1,
        NgWordUseCount: 0,
        UserState: 1,
        EntryDt: '2020/10/03 17:20:36',
        DeleteDt: '2020/10/03 17:20:36',
        LastLoginDt: '2020/10/03 17:20:36',
        MentorProfile: 'プロフィールテキスト'
      },
      AdminMemo: 'xxxxxxxxxxx'
    }
  }
}